import { render } from "./ForumTopicDetail.vue?vue&type=template&id=3202596a&scoped=true"
import script from "./ForumTopicDetail.vue?vue&type=script&lang=js"
export * from "./ForumTopicDetail.vue?vue&type=script&lang=js"

import "./ForumTopicDetail.vue?vue&type=style&index=0&id=3202596a&lang=css"
import "./ForumTopicDetail.vue?vue&type=style&index=1&id=3202596a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3202596a"]])

export default __exports__